import 'reflect-metadata'
import ReactDOM from 'react-dom/client'
import { setupErrorHandler } from './ErrorHandler'
import WrappedApp from './app/app'

setupErrorHandler()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
    // https://github.com/facebook/react/issues/24502
    // <React.StrictMode>
    <WrappedApp />
    // </React.StrictMode>
)
